import jQuery from 'jquery';
import Swiper from 'swiper';

var UIAPP = (function ($) {
    
    var throttle = function (callback, interval) {
        var wait = false;
        return function () {
            if (!wait) {
                callback.call();
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, interval);
            }
        };
    };
    var debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    
    var drawAlbumList = {
        set: function () {
            var target = $('.feed-album-list .feed-item');
            if (target.length === 0) return;
            this._init(target);
            this._resize(target);
        },
        init: function (target) {
            var width = target.width();
            var height = target.parents('.main-card-box').length === 0 ? width * 0.72 : width * 0.53 ;
            var feedWrap = $('.feed-album-list .feed-contents-wrap');
            feedWrap.height(height);
            var lineHeight = 16;
            var line = parseInt(height / lineHeight);
            var cutTextHeight = function (selector, line) {
                $(selector).each(function () {
                    $(this).height(lineHeight * line);
                    $(this).css('-webkit-line-clamp', line + '');
                });
            };
            cutTextHeight('.feed-txt', line);
        },
        resize: function (target) {
            var self = this;
            $(window).on('resize', function () {
                self._init(target);
            });
        }
    };
    
    
    var calCardTxtLine = {
        set: function() {
            var target = $('.feed-album-list .feed-txt');
            if (target.length === 0 ) return;
            var txtWrapper = $('.feed-album-list .feed-contents-wrap');
            
            this._cal(target, txtWrapper);
            this._resize(target, txtWrapper);
        },
        _cal : function (target, txtWrapper) {
            var txtHeight = txtWrapper.innerHeight() + 4;
            var lineHeight = 16;
            var txtLine = parseInt(txtHeight / lineHeight);
            $(target).height(lineHeight * txtLine);
            $(target).css('-webkit-line-clamp', txtLine + '');
        },
        _resize : function (target, txtWrapper) {
            var self = this;
            $(window).on('resize', function () {
                self._cal(target, txtWrapper);
            } );
        }
    };
    
    var changeGlobalLabel = function () {
        var globalSelectTarget = $('#select-global');
        var selectedOption = globalSelectTarget.children('option:selected');
        var label = globalSelectTarget.siblings('.global-label');
        label.find('.global-txt').text(selectedOption.text());
        label.find('.icon-flag').attr('class', 'icon-flag ' + selectedOption.val());
    };
    
    var setIframeHeight = function () {
        var iframeWraper = $('.feed-editor-wrap p:has(iframe)');
        iframeWraper.css({
            'position': 'relative',
            'width': '100%',
            'padding-bottom': '56%',
            'margin-bottom': '15px'
        });
    };
    
    var hidePopup = function () {
        var trigger = $('.popup-fadeout');
        if (trigger.length === 0) return;
        var popupContainer = trigger.parents('.popup-container');
        if (popupContainer.length) {
            trigger.on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                popupContainer.fadeOut();
                $('body').removeClass('fixed');
            });
        }
    };
    
    var sideNav = {
        set: function () {
            var trigger = $('#side-nav-link');
            if (trigger.length === 0) return;
            if ($._data(trigger[0], 'events') !== undefined) return;
            var sideNav = $('.lnb-myact');
            var sideNavDimmed = $('.lnb-dimmed');
            var sideNavClose = sideNav.find('.lnb-close');
            this._open(trigger, sideNav, sideNavDimmed);
            this._close(sideNavClose, sideNav, sideNavDimmed);
            this._close(sideNavDimmed, sideNav, sideNavDimmed);
        },
        _open : function (trigger, sideNav, sideNavDimmed) {
            trigger.on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                var sideNavContents = sideNav.find('.lnb-contents');
                var sideNavProfile = sideNav.find('.profile-wrap');
                sideNavContents.css('top', sideNavProfile.height());
                sideNav.addClass('on');
                sideNavDimmed.show();
            });
        },
        _close : function (trigger, sideNav, sideNavDimmed) {
            if(trigger.length === 0) return;
            trigger.on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                sideNav.removeClass('on');
                sideNavDimmed.hide();
            });
        }
    };
    
    // [D] floating 踰꾪듉 �몃줈 �뺣젹 �댁뒋濡쒖씤�� collapsing 湲곕뒫 �ъ슜�섏� �딆쓬.
    var toggleFloatingBtn = function() {
        var floatingBtn = $('.floating-btn');
        $(window).scroll(UIAPP.debounce(function () {
            floatingBtn.toggleClass('hidden');}, 400, true));
        $(window).scroll(UIAPP.debounce(function () {
            floatingBtn.toggleClass('hidden');}, 400));
    };
    
    var toggleTopBtn = function() {
        var topBtn = $('.floating-btn-top');
        var topBtnWrap = topBtn.parent();
        $(window).scroll(UIAPP.debounce(function () {
            topBtnWrap.fadeIn(500);
        }, 2000, true));
        $(window).scroll(UIAPP.debounce(function () {
            topBtnWrap.fadeOut(500);
        }, 2000));
        topBtn.on('click', function (e) {
            e.stopPropagation();
            $('html, body').animate({scrollTop: 0}, {duration: 1000, easing: 'easeInOutExpo'});
            
        });
    };
    
    var toggleDropdown = function() {
        var dropdownBtn = $('.dropdown-btn');
        if(dropdownBtn.length === 0) return;
        var allDropdown = $('.dropdown-menu-list');
        dropdownBtn.on('click', function (e) {
            var dropdownMenu = $(this).siblings('.dropdown-menu-list');
            e.stopPropagation();
            e.preventDefault();
            if (dropdownMenu.is(':visible')) {
                allDropdown.hide();
            } else {
                allDropdown.hide();
                dropdownMenu.show();
            }
        });
        $(window).on('scroll', UIAPP.throttle(function () {
            allDropdown.hide();
            
        }, 200));
        $('html').click(function (e) {
            var dropdownMenu = $('.dropdown-menu-list');
            if(!(e.target === $(this)) && dropdownMenu.is(':visible')) {
                $('.dropdown-menu-list').hide();
            }
        });
    }
    
    var toggleFileDropdown = function() {
        var dropdownBtn = $('.file-dropdown-btn');
        if(dropdownBtn.length === 0) return;
        dropdownBtn.on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var dropdownMenu = $(this).siblings('.dropdown-file-list');
            var dropdownArrow = $(this).find('.file-head .sp');
            if (dropdownMenu.is(':visible')) {
                dropdownMenu.hide();
                dropdownArrow.attr('class', 'icon-down-arrow-lg sp');
            } else {
                dropdownMenu.show();
                dropdownArrow.attr('class', 'icon-up-arrow sp');
            }
        });
    };
    
    var drawCheckbox = {
        name: 'drawCheckbox',
        settings: {
            $el: {},
            name: 'formstyle'
        },
        init: function (options) {
            var opts = $.extend(true, this.settings, options);
            this.markup(opts);
            $.fn[opts._name] = this.setState.call(this);
        },
        getInputStateClases: function (input, namespace) {
            var wrapClassList = [];
            wrapClassList.push(namespace);
            wrapClassList.push(input.type ? namespace + '--' + input.type : '');
            wrapClassList.push(input.checked ? namespace + '--checked' : '');
            wrapClassList.push(input.disabled ? namespace + '--disabled' : '');
            return wrapClassList;
        },
        setState: function () {
            var self = this;
            return function (options) {
                var $inputs = $(this), wrapClassList = [];
                if (typeof options === 'string') {
                    var state = options;
                    $inputs.each(function (i, input) {
                        var wrapClassList = [];
                        if (state === 'enable') {
                            input.disabled = false;
                        }
                        if (state === 'disable') {
                            input.disabled = true;
                        }
                        if (state === 'check') {
                            input.checked = true;
                        }
                        if (state === 'uncheck') {
                            input.checked = false;
                        }
                        wrapClassList = self.getInputStateClases(input, 'formstyle');
                        $(input).parent().attr('class', '').addClass(wrapClassList.join(' '));
                    });
                }
            };
        },
        markup: function (options) {
            var self = this, $inputs = options.$el;
            $inputs.each(function (i, input) {
                var isStyle = $(input).parent().is('.formstyle');
                if (isStyle) {
                    return;
                }
                var iconClassName = 'formstyle__icon', wrapClassList = self.getInputStateClases(input, 'formstyle');
                $(input).wrap('<span></span>')
                    .parent()
                    .addClass(wrapClassList.join(' '))
                    .append('<i class="' + iconClassName + '"></i>');
            }).on('focusin', function () {
                var $input = $(this);
                $input.parent().addClass('formstyle--focused');
            }).on('focusout', function () {
                $inputs.parent().removeClass('formstyle--focused');
            });
            setTimeout(function () {
                $inputs.on('change', function () {
                    var $input = $(this);
                    if (this.type === 'checkbox') {
                        $input.parent().toggleClass('formstyle--checked');
                    }
                    if (this.type === 'radio') {
                        $inputs.filter('[type=radio]').filter('[name=' + $input[0].name + ']').parent().removeClass('formstyle--checked');
                        $input.parent().addClass('formstyle--checked');
                    }
                });
            }, 200);
        }
    };
    
    // [D] folder, unfolder notice
    var toggleNotice = function () {
        return $('.notice-link').each(function () {
            var event = $._data(this, 'events');
            if (event !== undefined && event['click'] ) return;
            var noticePreview = $('#notice-preview');
            var noticeBtn = $('.notice-btn-wrap');
            var swiperWrap = noticePreview.find('.swiper-wrapper');
            var arrowIcon = $(this).children('.sp');
            
            var column = $('body').hasClass('sdk') ? 1 : 2;
            if(swiperWrap.children().length <= column)
                noticeBtn.fadeOut(200);
            
            var swiperOptions = {
                nextButton: '#notice-next-btn',
                prevButton: '#notice-prev-btn',
                slidesPerView: 1,
                slidesPerColumn: column,
                autoplay: 3000,
                autoplayDisableOnInteraction: false,
                spaceBetween: 0,
                onlyExternal: true
                // pagination: '.swiper-pagination',
                // paginationType: 'fraction',
            };
            var swiper = new Swiper('.swiper-container', swiperOptions);
            $(this).on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (noticePreview.hasClass('is-closed')) {
                    arrowIcon.attr('class', 'icon-up-arrow sp');
                    if(swiperWrap.children().length > 1)
                        noticeBtn.fadeIn(200);
                    noticePreview.removeClass('is-closed');
                } else {
                    arrowIcon.attr('class', 'icon-down-arrow-lg sp');
                    noticePreview.addClass('is-closed');
                    noticeBtn.fadeOut(200);
                }
            });
        });
    };
    
    var toggleMenu = function() {
        return $('.menu-toggle:not(.menu-link)').each(function() {
            var dropdownMenu = $('.main-menu-popup');
            var gnbHeight = $('.gnb').length !== 0 ? 41 : 0;
            var positionTop = gnbHeight;
            $(this).on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (dropdownMenu.is(':visible')) {
                    dropdownMenu.removeClass('is-open');
                    $('html, body').css('overflow', 'initial');
                    $(window).scrollTop(dropdownMenu.data('scrollTop'));
                } else {
                    dropdownMenu.data('scrollTop', $(window).scrollTop());
                    if($('body').hasClass('sdk') && $('.side-nav').length !== 0) {
                        positionTop = $(window).innerWidth() > 460 ? gnbHeight : gnbHeight + 64;
                    }
                    dropdownMenu.css('top', positionTop);
                    dropdownMenu.addClass('is-open');
                    $('html, body').css('overflow', 'hidden');
                }
            });
            $(window).on('resize', function() {
                if($('body').hasClass('sdk') && $('.side-nav').length !== 0) {
                    positionTop = $(window).innerWidth() > 460 ? gnbHeight : gnbHeight + 64;
                }
                dropdownMenu.css('top', positionTop);
            });
        });
    };
    var slidingMainTab = function(target) {
        var tabList = $('.main-tab-list'); // �� 由ъ뒪��
        var tabBar = $('.main-tab-bar'); // �� 諛�
        
        var prevTab = $('.main-tab-item.on'); // �댁쟾 ��
        var clickedTab = $(target).parent();
        // prevent animate duplicate
        if($('.main-tab-item.ing').length !== 0) return;
        // prev tab
        var prevLeft = prevTab.position().left + 4;
        var prevWidth = prevTab.width();
        
        prevTab.removeClass('on');
        clickedTab.addClass('ing');
        var pLeft = clickedTab[0].offsetLeft - 14; // scrollWidth �� ��� �대┃�� ��쓽 left �꾩튂
        var scrollWidth = tabList[0].scrollWidth; // �� �꾩껜 湲몄씠
        var offsetWidth = tabList[0].offsetWidth; // �� �붾㈃ 湲몄씠
        var position = (offsetWidth > (scrollWidth - pLeft)) ? offsetWidth - (scrollWidth-pLeft) + 14 : 14;
        
        tabBar.css({
            // �댁쟾 �� �꾩튂濡� tabBar �명똿
            'display': 'block',
            'width': prevWidth,
            'left': prevLeft
        }).animate({
            // �좏깮�� ��쑝濡� tabBar �대룞
            width: clickedTab.width(),
            left: position
        }, 0, function() {
            // 留곹겕 tabBar瑜� �앹꽦�쒗궡怨� �숈떆�� �꾩뿭 tabBar �④�
            clickedTab.removeClass('ing').addClass('on');
            tabBar.css('display', 'none');
        });
        
        tabList.animate({
            scrollLeft: pLeft
        }, 300);
    };
    
    var slidingSubTab = function(target) {
        var tabList = $('.sub-tab-list'); // �� 由ъ뒪��
        
        var prevTab = $('.sub-tab-item.on');
        var clickedTab = $(target).parent();
        
        // prevent animate duplicate
        if($('.sub-tab-item.ing').length !== 0) return;
        
        prevTab.removeClass('on');
        clickedTab.addClass('on');
        var pLeft = clickedTab[0].offsetLeft - 19; // scrollWidth �� ��� �대┃�� ��쓽 left �꾩튂
        tabList.animate({
            scrollLeft: pLeft
        }, 300);
    };
    
    var slidingMinorTab = function(target) {
        var tabList = $('.minor-tab-list'); // �� 由ъ뒪��
        var tabBar = $('.minor-tab-bar'); // �� 諛�
        
        var prevTab = $('.minor-tab-item.on'); // �댁쟾 ��
        var clickedTab = $(target).parent();
        // prevent animate duplicate
        if($('.minor-tab-item.ing').length !== 0) return;
        // prev tab
        var prevLeft = prevTab.position().left + 6;
        var prevWidth = prevTab.width();
        
        prevTab.removeClass('on');
        clickedTab.addClass('ing');
        var pLeft = clickedTab[0].offsetLeft - 14; // scrollWidth �� ��� �대┃�� ��쓽 left �꾩튂
        var scrollWidth = tabList[0].scrollWidth; // �� �꾩껜 湲몄씠
        var offsetWidth = tabList[0].offsetWidth; // �� �붾㈃ 湲몄씠
        var position = (offsetWidth > (scrollWidth - pLeft)) ? offsetWidth - (scrollWidth-pLeft) + 14 : 14;
        
        tabBar.css({
            // �댁쟾 �� �꾩튂濡� tabBar �명똿
            'display': 'block',
            'width': prevWidth,
            'left': prevLeft
        }).animate({
            // �좏깮�� ��쑝濡� tabBar �대룞
            width: clickedTab.width(),
            left: position
        }, 300, function() {
            // 留곹겕 tabBar瑜� �앹꽦�쒗궡怨� �숈떆�� �꾩뿭 tabBar �④�
            clickedTab.removeClass('ing').addClass('on');
            tabBar.css('display', 'none');
        });
        
        tabList.animate({
            scrollLeft: pLeft
        }, 300);
    };
    
    var fixTab = function() {
        return $('.main-menu').each(function () {
            var mainMenu = $(this);
            var initOffsetTop = mainMenu.offset().top;
            var mainContents = $('.main-contents');
            mainContents.css('padding-top', 0);
            mainMenu.removeClass('fixed');
            
            var gnbHeight = $('.container').offset().top + parseInt($('.container').css('padding-top'));
            $(window).on('resize', function () {
                gnbHeight = $('.container').offset().top + parseInt($('.container').css('padding-top'));
            });
            $(window).on('scroll', function () {
                if($('.main-menu').length === 0) {
                    return;
                }
                
                var offsetTop = mainMenu.offset().top;
                if (offsetTop - $(window).scrollTop() < gnbHeight) {
                    mainContents.css('padding-top', mainMenu.height());
                    mainMenu.addClass('fixed');
                } else if (mainMenu.hasClass('fixed') &&  initOffsetTop - gnbHeight >= $(window).scrollTop()) {
                    mainContents.css('padding-top', 0);
                    mainMenu.removeClass('fixed');
                }
            });
        });
    };
    
    var fixSdkTab = function() {
        return $('.main-menu-fixed').each(function () {
            var mainMenu = $(this);
            var mainContents = $('.main-contents');
            var paddingTop = mainMenu.height();
            mainContents.css('padding-top', paddingTop);
        });
    };
    
    var expandFeedAlert = function() {
        return $('.feed-alert-page').each(function() {
            var feedAlertPage = $(this);
            feedAlertPage.css('min-height', $(window).innerHeight() - feedAlertPage.offset().top);
            $(window).on('resize', function() {
                feedAlertPage.css('min-height', $(window).innerHeight() - feedAlertPage.offset().top);
            });
        });
    };
    
    var showAllTag = function() {
        var tagBox = $('.tag-box');
        var showTagBtn = $('.tag-box .header-link');
        if(showTagBtn.length === 0) return;
        showTagBtn.on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            
            // var arrow = showTagBtn.children();
            if(tagBox.hasClass('all')) {
                tagBox.removeClass('all');
                // showTagBtn.text('紐⑤몢蹂닿린').append(arrow);
            } else {
                tagBox.addClass('all');
                // showTagBtn.text('�묎린').append(arrow);
            }
        });
    };
    
    var openTagList = function() {
        return $('.tag-link').each(function() {
            var allTag = $('.tag-link');
            var tag = $(this);
            
            $(tag).on('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                
                allTag.removeClass('on');
                tag.addClass('on');
                
                $('.tag-card-wrap').addClass('is-visible');
            });
        });
    };
    
    var closeTagList = function() {
        var closeTagBtn = $('.tag-card-wrap .tag-close-link');
        if(closeTagBtn.length === 0) return;
        closeTagBtn.on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            
            $('.tag-card-wrap').removeClass('is-visible');
        });
    };
    
    var fixGnb = function() {
        return $('.app-banner').each(function() {
            var container = $(".container");
            container.css('padding-top', 0);
            
            var appBanner = $(this);
            var gnb = $('.gnb');
            
            $(window).on('scroll', function() {
                var scrollHeight = $(document).scrollTop();
                var appBannerHeight = appBanner.innerHeight();
                if(scrollHeight >= appBannerHeight || $('.app-banner').length === 0) {
                    gnb.css('position', 'fixed');
                    container.css('padding-top', '41px');
                } else {
                    gnb.css('position', 'relative');
                    container.css('padding-top', '0');
                }
            });
        });
    };
    
    return {
        throttle: throttle,
        debounce: debounce,
        drawAlbumList: drawAlbumList,
        calCardTxtLine: calCardTxtLine,
        changeGlobalLabel: changeGlobalLabel,
        setIframeHeight: setIframeHeight,
        hidePopup: hidePopup,
        sideNav: sideNav,
        toggleFloatingBtn: toggleFloatingBtn,
        toggleTopBtn: toggleTopBtn,
        toggleDropdown: toggleDropdown,
        drawCheckbox: drawCheckbox,
        toggleFileDropdown: toggleFileDropdown,
        toggleNotice: toggleNotice,
        toggleMenu: toggleMenu,
        slidingMainTab: slidingMainTab,
        slidingSubTab: slidingSubTab,
        slidingMinorTab: slidingMinorTab,
        fixTab: fixTab,
        fixSdkTab: fixSdkTab,
        expandFeedAlert: expandFeedAlert,
        showAllTag: showAllTag,
        openTagList: openTagList,
        closeTagList: closeTagList,
        fixGnb: fixGnb
    };
    
}(jQuery));

(function ($) {
    
    // [D] Select Global
    $.fn.selectGlobal = function () {
        return this.each(function () {
            $(this).change(UIAPP.changeGlobalLabel);
        });
    };
    
    $('.sub-tab-link').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        
        UIAPP.slidingSubTab(e.currentTarget);
    });
    
    $('.main-tab-link').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        
        UIAPP.slidingMainTab(e.currentTarget);
    });
    
    $('.minor-tab-link').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
    
        UIAPP.slidingMinorTab(e.currentTarget);
    });
    
    // [D] �앹뾽 �リ린
    UIAPP.hidePopup();
    // [D] �곗씠�� 濡쒕뱶 肄쒕갚�� �쎌엯
    UIAPP.calCardTxtLine.set();
    // [D] iframe height 媛� 議곗젅
    UIAPP.setIframeHeight();
    // [D] SideNav open,close / gnb �뚮뜑留� �꾨즺 �� �쎌엯.
    UIAPP.sideNav.set();
    
    // [D] �� �ㅽ겕濡� �� 怨좎젙
    UIAPP.fixTab();
    UIAPP.fixSdkTab();
    
    // [D] �좉� 而댄룷�뚰듃
    UIAPP.toggleDropdown();
    UIAPP.toggleFileDropdown();
    UIAPP.toggleNotice();
    UIAPP.toggleMenu();
    
    // [D] collapsing 踰꾪듉
    UIAPP.toggleFloatingBtn();
    UIAPP.toggleTopBtn();
    
    UIAPP.expandFeedAlert();
    
    // [D] �ㅽ넗釉� 硫붿씤 異붿쿇�쒓렇 �곸뿭 �대깽��
    UIAPP.showAllTag();
    // app.openTagList();
    // app.closeTagList();
    
    UIAPP.fixGnb();

    
})(jQuery);
export {UIAPP};
// export default app;


// WEBPACK FOOTER //
// ./static/js/stove.js